import csapi from "@/api/csapi";
import store from "@/store";

let requisicoesPendentes = 0;

const requisitarComLoader = (requisicao, exibirLoader) => {
  if (!exibirLoader) return requisicao();
  if (requisicoesPendentes++ === 0) {
    store.commit("loader/showLoader", "Carregando FAQ...");
  }
  return Promise.resolve()
    .then(requisicao)
    .finally(() => {
      requisicoesPendentes -= 1;
      if (requisicoesPendentes === 0) store.commit("loader/hideLoader");
    });
};

export const buscarResumoFaq = (exibirLoader = true) =>
  requisitarComLoader(() => csapi.get("/v1/faq"), exibirLoader).then(({ data }) => data);

export const buscarCategoriaFaq = id =>
  csapi.get(`/v1/faq/categorias/${encodeURIComponent(id)}`).then(({ data }) => data);

export const buscarSessaoFaq = id =>
  csapi.get(`/v1/faq/sessoes/${encodeURIComponent(id)}`).then(({ data }) => data);

export const buscarArtigosSessaoFaq = id =>
  csapi.get(`/v1/faq/sessoes/${encodeURIComponent(id)}/artigos`).then(({ data }) => data);

export const vincularArtigosSessaoFaq = (id, idsartigos) =>
  csapi.post(`/v1/faq/sessoes/${encodeURIComponent(id)}/artigos`, { idsartigos }).then(({ data }) => data);

export const desvincularArtigosSessaoFaq = (id, idsartigos) =>
  csapi.delete(`/v1/faq/sessoes/${encodeURIComponent(id)}/artigos`, { idsartigos }).then(({ data }) => data);

export const buscarArtigosFaq = (exibirLoader = true) =>
  requisitarComLoader(() => csapi.get("/v1/faq/artigos"), exibirLoader).then(({ data }) => data);

export const buscarArtigoFaq = id =>
  csapi.get(`/v1/faq/artigos/${encodeURIComponent(id)}`).then(({ data }) => data);

export const excluirArtigoFaq = id =>
  csapi.delete(`/v1/faq/artigos/${encodeURIComponent(id)}`);

export const atualizarStatusArtigosFaq = corpo =>
  csapi.patch("/v1/faq/artigos/status", corpo).then(({ data }) => data);

export const criarArtigoFaq = ({ idsessoes, titulo, descricao, conteudo, autor, video, ultimoeditor, atualizadoem, criadoem }) =>
  csapi.post("/v1/faq/artigos", {
    idsessoes, titulo, descricao, conteudo, autor, ultimoeditor, atualizadoem, criadoem,
    status: "rascunho", url: "", video: Boolean(video)
  }).then(({ data }) => data);

export const atualizarArtigoFaq = (id, alteracoes) => {
  const corpo = {};
  ["idsessoes", "titulo", "descricao", "conteudo", "video", "status", "permissao", "ultimoeditor", "atualizadoem"].forEach(campo => {
    if (Object.prototype.hasOwnProperty.call(alteracoes, campo)) {
      corpo[campo] = alteracoes[campo];
    }
  });
  return csapi.patch(`/v1/faq/artigos/${encodeURIComponent(id)}`, corpo)
    .then(({ data }) => data);
};

export const criarSessaoFaq = ({ idfaqcategoria, nome, descricao, ordenacao, status }) =>
  csapi.post("/v1/faq/sessoes", {
    idfaqcategoria, nome, descricao, ordenacao, url: "", status
  }).then(({ data }) => data);

export const atualizarSessaoFaq = (id, alteracoes) => {
  const corpo = {};
  ["idfaqcategoria", "nome", "descricao", "ordenacao", "status"].forEach(campo => {
    if (Object.prototype.hasOwnProperty.call(alteracoes, campo)) {
      corpo[campo] = alteracoes[campo];
    }
  });
  return csapi.patch(`/v1/faq/sessoes/${encodeURIComponent(id)}`, corpo)
    .then(({ data }) => data);
};

export const criarCategoriaFaq = ({ nome, descricao, status }) =>
  csapi.post("/v1/faq/categorias", { nome, descricao, status, url: "" }).then(({ data }) => data);

export const atualizarCategoriaFaq = (id, alteracoes) => {
  const corpo = {};
  ["nome", "descricao", "status"].forEach(campo => {
    if (Object.prototype.hasOwnProperty.call(alteracoes, campo)) {
      corpo[campo] = alteracoes[campo];
    }
  });
  return csapi.patch(`/v1/faq/categorias/${encodeURIComponent(id)}`, corpo)
    .then(({ data }) => data);
};

// O DELETE retorna 204 sem corpo; não há dados para desserializar.
export const excluirCategoriaFaq = id =>
  csapi.delete(`/v1/faq/categorias/${encodeURIComponent(id)}`);

export const excluirSessaoFaq = id =>
  csapi.delete(`/v1/faq/sessoes/${encodeURIComponent(id)}`);
